import * as util from '@/public/util'

export default function genShareInfo (teamInfo) {
  let contentData = window.contentData
  let searchStr = util.genUrlSearchFromObj(teamInfo)
  let link = `${window.data_source.sharelink}/team-bag/dist/activity.html?${searchStr}`
  if (util.isCeshi) {
    link = `http://minner.jr.jd.com/flowh5/team-bag/dist/activity.html?${searchStr}`
  }

  let shareInfo = {
    ...contentData.share,
    link,
  }
  return shareInfo
}



// WEBPACK FOOTER //
// ./src/public/genShareInfo.js